import { Address } from '@/api/business-partner/business-partner.types';
import Box from '@/components/base/box.component';
import { formatAddressNewLine } from '@/utils/format-address-new-line';
import { Skeleton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AddressInformationProps {
  defaultBillingAddress: Address | undefined;
  defaultShippingAddress: Address | undefined;
  isLoading: boolean;
}

export function AddressInformation({
  defaultBillingAddress,
  defaultShippingAddress,
  isLoading,
}: AddressInformationProps) {
  const { t } = useTranslation('customer');

  return (
    <Stack
      sx={{
        width: '100%',
        justifyContent: 'space-between',
      }}
      direction={'row'}
      spacing={4}
    >
      <Box sx={{ width: '100%' }}>
        <Typography variant={'subtitle2'}>
          {t('account.myData.addresses.billing')}
        </Typography>
        <Typography sx={{ whiteSpace: 'pre-wrap' }}>
          {isLoading ? (
            <>
              <Skeleton width="70%" />
              <Skeleton width="50%" />
              <Skeleton width="60%" />
            </>
          ) : defaultBillingAddress ? (
            formatAddressNewLine(defaultBillingAddress)
          ) : (
            t('account.myData.addresses.error')
          )}
        </Typography>
      </Box>
      <Box sx={{ width: '100%' }}>
        <Typography variant={'subtitle2'}>
          {t('account.myData.addresses.shipping')}
        </Typography>
        <Typography sx={{ whiteSpace: 'pre-wrap' }}>
          {isLoading ? (
            <>
              <Skeleton width="70%" />
              <Skeleton width="50%" />
              <Skeleton width="60%" />
            </>
          ) : defaultShippingAddress ? (
            formatAddressNewLine(defaultShippingAddress)
          ) : (
            t('account.myData.addresses.error')
          )}
        </Typography>
      </Box>
    </Stack>
  );
}
